// extracted by mini-css-extract-plugin
export default {"requestedTherapist":"RequestedTherapist_requestedTherapist__b+xi3","requestedRoom":"RequestedTherapist_requestedRoom__Bczb9"};